// import { useState } from "react";
import searchimg from "../assets/images/search.png";
// import { Link } from "react-router";
import styles from "../styles/header.module.scss";
import { useI18n } from "../../features/i18n/useI18n";

export const SearchBar = () => {
  const { t } = useI18n();
  // const [resultSearch, setResultSearch] = useState([]);
  // const [search, setSearch] = useState("");

  // const searchEnter = async (key: string) => {
  //   if (key === "Enter" && search.length > 3) {
  //     // const { data } = await axios.get(
  //     //   `${baseUrl}/api/v1/project/projects/auth.email/${search}`,
  //     //   {
  //     //     headers: { Authorization: "Basic YWRtaW46VDF0NE0zZDFBYjRLKio=" },
  //     //   }
  //     // );

  //     // setResultSearch(data);
  //   } else {
  //     setResultSearch([]);
  //   }
  // };

  return (
    <div className={styles["header__search"]}>
      <img
        src={searchimg}
        alt="search"
        className={styles["header__search-image"]}
        width={13}
        height={13}
      />
      <input
        className={styles["header__input-search"]}
        type="text"
        name="search"
        placeholder={t("search")}
      // onChange={(e: any) => setSearch(e.target.value)}
      // onKeyDown={(e: any) => searchEnter(e.key)}
      />
      {/* TODO: por revisar */}
      {/* {resultSearch.length > 0 ? (
        <div className={styles["header__result-search"]}>
          {resultSearch.map((result: any) => (
            <Link
              key={result.id}
              className={styles["header__result-item"]}
              to={`/detailproject/`}
              path={`/detailproject/${result.id}`}
            >
              {result.name}
              result.name
            </Link>
          ))}
        </div>
      ) : null} */}
    </div>
  );
};

